import React, { useEffect, useState } from 'react';
import { Container } from 'react-bootstrap';
import EmailIcon from 'assets/img/verification/emailsent.svg';
import { useParams } from 'react-router-dom';
import { useResentVerficationLinkMutation } from 'service/authQuery/authQuery';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';

const timeout = 60000;

function VerificationSent() {
  const [resent, setResent] = useState(true);
  const [remainingTime, setRemainingTime] = useState(timeout / 1000);
  const { id } = useParams();

  const [resentVerificationLink] = useResentVerficationLinkMutation();

  const handleResentMail = () => {
    setResent(true);
    setRemainingTime(timeout / 1000);
    resentVerificationLink(id);
  };

  useEffect(() => {
    if (resent) {
      const interval = setInterval(() => {
        setRemainingTime(prev => {
          if (prev <= 1) {
            setResent(false);
            clearInterval(interval);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [resent]);

  return (
    <Container
      fluid
      className="vh-100 d-flex justify-content-center align-items-center flex-column"
    >
      <img src={EmailIcon} width={150} className="mb-2" />
      <p className="fs-4">Email Confirmation</p>
      <p className="text-center mb-8">
        We have sent you an email for account confirmation. Upon receiving the
        email, <br /> please follow the link to complete your registration.
      </p>
      <p>
        If you have not received any mail, please{' '}
        <Button
          className={classNames('text-primary border border-0 bg-body p-2', {
            'user-select-none': resent,
            'cursor-pointer': !resent
          })}
          disabled={resent}
          onClick={handleResentMail}
        >
          click here to resend it
        </Button>
        {resent && (
          <span className="ms-2 text-muted">
            (You can resend in {remainingTime}s)
          </span>
        )}
        .
      </p>
    </Container>
  );
}

export default VerificationSent;
